
class Siteheader {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-siteheader',
            breakpoint: '1024',
            hiddenClassname: 'siteheader--hidden',
        };

        this.settings = Object.assign({}, defaults, options);
        this.$siteheader = element;
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.handleVisibility();

        window.addEventListener('change', () => {
            this.handleVisibility();
        });

        window.eventScroller.customFunctions.push(() => {
            this.handleVisibility();
        });
    }

    handleVisibility () {
        const siteheaderHeight = this.$siteheader.offsetHeight;

        if (window.scrollPosition > siteheaderHeight) {
            if (window.scrollDirection === 'down') {
                this.toggleHeader(false);
            } else {
                this.toggleHeader(true);
            }
        } else {
            this.toggleHeader(true);
        }
    }

    toggleHeader (visible) {
        const breakpoint = window.matchMedia('(max-width: ' + this.settings.breakpoint + 'px)');

        if (breakpoint.matches) {
            if (visible === true) {
                if (this.$siteheader.classList.contains(this.settings.hiddenClassname)) {
                    this.$siteheader.classList.remove(this.settings.hiddenClassname);
                }
            } else {
                if (!this.$siteheader.classList.contains(this.settings.hiddenClassname)) {
                    this.$siteheader.classList.add(this.settings.hiddenClassname);
                }
            }
        } else {
            this.$siteheader.classList.remove(this.settings.hiddenClassname);
        }
    }
}

export default Siteheader;
